import React, { useState, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";

const AppContext = React.createContext();

const AppProvider = ({ children }) => {
  const { t, i18n } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [countdown, setCountdown] = useState(5);

  const handleLanguageChange = (lang) => {
    const htmlElement = document.documentElement;
    const language = lang || i18n.language;
    
    i18n.changeLanguage(language);
    htmlElement.lang = language;
    htmlElement.setAttribute("dir", language === "ar" ? "rtl" : "ltr");
  };

  useEffect(() => {
    setIsLoading(true);
    handleLanguageChange();
    setIsLoading(false);
  }, [i18n.language]);

  useEffect(() => {
    if (!showModal) return;

    const interval = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    if (countdown <= 0) {
      setShowModal(false);
      setCountdown(5);
      clearInterval(interval);
    }

    return () => clearInterval(interval);
  }, [showModal, countdown]);

  const contextValue = {
    handleLanguageChange,
    t,
    isLoading,
    showModal,
    setShowModal,
    countdown,
    setCountdown
  };

  

  return (
    <AppContext.Provider value={contextValue}>
      {children}
    </AppContext.Provider>
  );
};

const useGlobalContext = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error("useGlobalContext must be used within an AppProvider");
  }
  return context;
};

export { AppContext, AppProvider, useGlobalContext };
